import React, { Component } from 'react'
import { Switch, Route } from 'react-router'
import { BrowserRouter as Router } from 'react-router-dom'
import Nav from './components/Nav'
import Footer from './components/Footer'
import Home from './screens/Home'
import Team from './screens/Team'
import Subject from './screens/Subject'
import Archive from './screens/Archive'
import NotFound from './screens/NotFound'
import ThemeProvider from './providers/ThemeProvider'
import StateProvider from './providers/StateProvider'

class App extends Component {
	render() {
		return (
			<Router>
				<ThemeProvider>
					<StateProvider>
						<Nav />
						<Switch>
							<Route path="/" exact component={Home} />
							<Route path="/team" exact component={Team} />
							<Route path="/subject/:number" exact component={Subject} />
							<Route path="/archive" exact component={Archive} />
							<Route component={NotFound} />
						</Switch>
		        <Footer />
					</StateProvider>
			  </ThemeProvider>
			</Router>
		)
	}
}

export default App
